module.exports = __webpack_public_path__ + "static/media/target.db0f999e.svg";